export { default } from './FavoriteProductButton';
